import React from 'react';
import { Root } from 'tanok';

import { BesidaView } from '../index';

export const tanokMountWrapper = (tanokStream, store) => (
    <Root store={store} tanokStream={tanokStream}>
        <BesidaView />
    </Root>
);
